import { DateInput } from "components/DesignSystem/DateInput/DateInput";
import { YYYY_MM_DD } from "constants/date";
import dayjs from "dayjs";
import { Field, FieldProps, Form, Formik } from "formik";
import { useToast } from "hooks/useToast";
import React from "react";
import { useUpdateTaskAssigneeAdminMutation } from "store/apis/serviceTeam";
import { useUpdateTaskMutation } from "store/apis/task";
import { BackendError } from "types/utils/error";

export const TaskDeadlineUpdate = ({
  taskId,
  deadline,
}: {
  taskId: string;
  deadline: string | null;
}) => {
  const { successToast, alertToast } = useToast();
  const [updateTask] = useUpdateTaskMutation();

  const handleBookkeeperStartedOn = async (date: Date) => {
    try {
      if (taskId) {
        await updateTask({
          deadline: dayjs(date).format(YYYY_MM_DD),
          task_id: taskId,
          operation: "DEADLINE_UPDATE",
        }).unwrap();
        successToast({
          message: "Task deadline updated successfully!",
        });
      }
    } catch (error) {
      alertToast({
        message: (error as BackendError)?.data?.error?.message,
      });
    }
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Formik onSubmit={() => {}} initialValues={{ task_deadline: deadline }}>
        {() => (
          <Form className="t-m-0">
            <Field name="task_deadline">
              {({ field }: FieldProps) => {
                return (
                  <DateInput
                    {...field}
                    portalId={field.name}
                    onDateChange={(date) => {
                      handleBookkeeperStartedOn(date);
                    }}
                    defaultValue={deadline || ""}
                  />
                );
              }}
            </Field>
          </Form>
        )}
      </Formik>
    </div>
  );
};
